import axios from "axios";

const apiBaseUrl = 'https://api.devsmore.com';
const subContactUrl = '/contact';

export function sendEmail(data) {
    return axios({
        method: 'post',
        data: data,
        url: `${apiBaseUrl}${subContactUrl}`,
        withCredentials: false
      });
}